import React from 'react';
import { useDispatch } from 'react-redux';
import { useGetAccessesList } from '@data/documentSignedUrl/hooks/useGetAccessesList/useGetAccessesList';
import { ApiActionPayload } from '@interfaces/ApiAction/ApiActionPayload';
import {
	GetUploadSignedUrlRequest,
	GetUploadSignedUrlResponse
} from '@data/documentSignedUrl/types/DocumentUploadSignedUrl.types';
import { ErrorStatusState } from '@interfaces/ErrorStatus/ErrorStatusState';
import { getSignedUrlForUploadAction } from '@data/documentSignedUrl/actionCreators/DocumentSignedUrlActionCreators';
import { DOCUMENT_SIGNED_URL_IDENTIFIER, PDF_CONTENT_TYPE } from '@utilities/constants';

export const useGetSignedUrlForUpload = (unitId: string) => {
	const dispatch = useDispatch();
	const accesses = useGetAccessesList(unitId);

	return React.useCallback(({ name: fileName }: File, overrides: Partial<ApiActionPayload<GetUploadSignedUrlRequest, ErrorStatusState, GetUploadSignedUrlResponse>> = {}) => {
		if (!accesses) return;
		dispatch(getSignedUrlForUploadAction({
			data: {
				fileName,
				contentType: PDF_CONTENT_TYPE,
				identifier: DOCUMENT_SIGNED_URL_IDENTIFIER,
				accesses,
			},
			...overrides,
		}));
	}, [accesses, dispatch]);
};
